module.exports = __webpack_public_path__ + "img/1bf882e6ee3f74fd73ee985aa637ab07.png";